import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { CustomHttpClientService } from './custom-http-client.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class EventService {

 url = environment.apiUrl;

 constructor(private http: CustomHttpClientService) {}

 postEvent(value: any): Observable<any> {
  const data = JSON.stringify(value);
  const formData: FormData = new FormData();
  const id = localStorage.getItem('residents');
  
  formData.append('id', id || '');
  formData.append('feedData', data);
  formData.append('eventImage', (value.file || null));

  return this.http.post<any>(`${this.url}events/eventCreate`, formData)
    .pipe(catchError(this.handleError));
}
  getEvents(id: any):Observable<any>{
    return this.http.get<any>(this.url+ 'events/getEvents/?id='+id);
  }

  getAllEvents(id: any):Observable<any>{
    return this.http.get<any>(this.url+ 'events/getAllEvents/?id='+id);
  }

  deleteEvent(id: any):Observable<any>{
     return this.http.delete<any>(this.url+'events/deleteEvent/'+id);
  }

  eventsLikes(id: any, userId: any):Observable<any>{
    let formData:FormData = new FormData;
     formData.append('eventId', id);
     formData.append('userId', userId);
     return this.http.post<any>(this.url+'events/addUpvote', formData);
  }

  getEventsById(id: any, action = null):Observable<any>{
    if(action === false){
      action = 'false';
    }else{
      action = null;
    }
    var params = '?id='+ id +'&action='+action;
    return this.http.get<any>(this.url+ 'events/getEventById/'+params)
  }

  updateEvent(value: any, id: any):Observable<any>{
    const Data = JSON.stringify(value);
    let formData:FormData = new FormData;
    formData.append('value', Data);
    formData.append('id', id);
    formData.append('eventImage', (value.file || null));
    return this.http.put<any>(this.url+'events/updateEvent',formData)
  }

  addPresent(eventId: any, id: any){
    let formData:FormData = new FormData;
    formData.append('id', id);
    formData.append('eventId', eventId);
    return this.http.put<any>(this.url+ 'events/addAttendance', formData);
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(error); // Return observable with error
  }
}
